import type { ChangeEvent, FC, ReactNode, Ref } from "react";

/**
 * Shape of the `error` object passed to {@link Textarea}. Mirrors a
 * react-hook-form `FieldError` (only the fields the underlying component reads).
 */
export interface TextareaError {
  message?: string;
  type?: string;
}

export interface TextareaProps {
  // PropTypes marks this `.isRequired`, but existing consumers (e.g.
  // TicketSlaReminderConfig) omit it, so it is typed optional to avoid
  // breaking those call sites.
  "data-testid"?: string;
  value?: string;
  onChange?: (event: ChangeEvent<HTMLTextAreaElement>) => void;
  name?: string;
  error?: TextareaError;
  wrapperClassName?: string;
  className?: string;
  label?: string;
  labelTop?: boolean;
  size?: string;
  required?: boolean;
  hideLabelHelper?: boolean;
  disabled?: boolean;
  readOnly?: boolean;
  password?: boolean;
  labelWidth?: number | string | false;
  isLarge?: boolean;
  placeholder?: string;
  onBlur?: () => void;
  onFocus?: () => void;
  inputRef?: Ref<HTMLTextAreaElement>;
  enableCopy?: boolean;
  title?: string;
  withHelp?: ReactNode;
  rowNumber?: number;
  resize?: string;
  viewMode?: boolean;
}

// The runtime `Textarea` export exists in `@SeemplicityDev/ticket-master`'s
// bundle but is not declared in its shipped `index.d.ts`. Augment the module
// to surface the export with proper types instead of falling back to `any`.
// TODO: remove this augmentation once `@SeemplicityDev/ticket-master` exports
// `Textarea` (and its props) from its type declarations.
declare module "@SeemplicityDev/ticket-master" {
  export const Textarea: FC<TextareaProps>;
}

// eslint-disable-next-line import/first -- import must follow the module augmentation above
import { Textarea } from "@SeemplicityDev/ticket-master";

export default Textarea;
